import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Interpolate } from 'react-i18next';
import EmptyStates from '../empty-states';
import withTranslate from '../../hoc/with-translate';
import styles from './no-member-results.scss';

export const NoMemberResults = ({ name, t }) => {
  const tryAgain = (
    <div>
      <Interpolate
        i18nKey={`no-member-results.no-members-found`}
        name={<span className={styles.term}>
          {name}
        </span>}
      />
      <br/>
      <Interpolate i18nKey="no-member-results.try-again"/>
    </div>
  );
  return (
    <EmptyStates className={styles.container} title={t('no-member-results.nothings-coming-up')} content={tryAgain}/>
  );
};

NoMemberResults.propTypes = {
  name: PropTypes.string.isRequired,
  t: PropTypes.func,
};

export default _.flowRight(withTranslate)(NoMemberResults);



// WEBPACK FOOTER //
// ./app/components/no-member-results/no-member-results.js